import { DirectUpload } from '@rails/activestorage';
import { CLIENT_ORIGIN } from '~/lib/constants';
import { getToken } from '~/lib/stores/token';

export interface FileWithPath extends globalThis.File {
  path: string;
}

export interface Blob {
  signedId: string;
  content: string;
  name: string;
}

export async function uploadBinaryFile(
  slug: string,
  name: string,
  file: FileWithPath,
  onUpload?: PromiseWithResolvers<void>,
) {
  const token = await getToken();

  const promise = new Promise<Blob>((resolve, reject) => {
    const upload = new DirectUpload(
      file,
      `${CLIENT_ORIGIN}/api/projects/${slug}/direct_uploads`,
      {
        directUploadWillCreateBlobWithXHR(request) {
          request.addEventListener('error', (event) => {
            const target = event.target as XMLHttpRequest;
            reject(target);
          });
          request.addEventListener('loadend', (event) => {
            const target = event.target as XMLHttpRequest;

            if (target.status >= 400) {
              reject(target);
            }
          });
        },
        directUploadWillStoreFileWithXHR() {
          onUpload?.resolve();
        },
      },
      {
        Authorization: `Bearer ${token}`,
      },
    );

    upload.create((error, blob) => {
      if (error) {
        // we prefer to handle errors in the listeners above
        setTimeout(() => {
          reject(error);
        });
      } else {
        resolve({
          signedId: blob.signed_id,
          content: `${CLIENT_ORIGIN}/storage/blobs/${blob.signed_id}/${name}`,
          name,
        });
      }
    });
  });

  promise.catch((error) => onUpload?.reject(error));

  return promise;
}
